import { createAsyncThunk } from '@reduxjs/toolkit';
import { normalize } from 'normalizr';

import * as SiteGroupApi from '@sophocles/api/siteGroup';
import * as SiteGroupCurfewApi from '@sophocles/api/siteGroupCurfew';
import * as SiteGroupWeatherConfigurationApi from '@sophocles/api/siteGroupWeatherConfiguration';
import { receiveCustomers } from '@sophocles/features/customers/slice';
import { SiteGroupSchema, SiteGroupWeatherConfigurationSchema } from '@sophocles/features/siteGroups/schema';

// Site Group Curfew

export const loadSiteGroupCurfews = createAsyncThunk(
  'siteGroupCurfews/loadMany',
  async (params, { rejectWithValue }) => {
    try {
      const data = await SiteGroupCurfewApi.fetchSiteGroupCurfews(params);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const loadSiteGroupCurfew = createAsyncThunk(
  'siteGroupCurfew/loadOne',
  async (siteGroupCurfewId, { rejectWithValue }) => {
    try {
      const data = await SiteGroupCurfewApi.fetchSiteGroupCurfew(siteGroupCurfewId);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const loadSiteGroupCurfewForSiteGroup = createAsyncThunk(
  'siteGroupCurfew/loadBySiteGroupId',
  async (siteGroupId, { rejectWithValue }) => {
    try {
      const data = await SiteGroupCurfewApi.fetchSiteGroupCurfewForSiteGroup(siteGroupId);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const editSiteGroupCurfew = createAsyncThunk(
  'siteGroupCurfew/edit',
  async ({ id, ...values }, { rejectWithValue }) => {
    try {
      const data = await SiteGroupCurfewApi.pathSiteGroupCurfew(id, values);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

// Site Group Weather Configuration

export const loadSiteGroupWeatherConfigurationForSiteGroup = createAsyncThunk(
  'siteGroupWeatherConfiguration/loadBySiteGroupId',
  async (siteGroupId, { rejectWithValue }) => {
    try {
      const data = await SiteGroupWeatherConfigurationApi.fetchSiteGroupWeatherConfigurationBySiteGroupId(siteGroupId);
      const normalizedData = normalize(data, SiteGroupWeatherConfigurationSchema);
      return normalizedData.entities.weatherConfigurations;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

export const editSiteGroupWeatherConfiguration = createAsyncThunk(
  'siteGroupWeatherConfiguration/edit',
  async ({ id, ...values }, { rejectWithValue }) => {
    try {
      const data = await SiteGroupWeatherConfigurationApi.patchSiteGroupWeatherConfiguration(id, values);
      return data;
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);

// Site Group — reads

export const loadSiteGroup = createAsyncThunk(
  'siteGroup/loadOne',
  async (siteGroupId, { dispatch, rejectWithValue }) => {
    try {
      const data = await SiteGroupApi.fetchSiteGroup(siteGroupId);
      const normalizedData = normalize(data, SiteGroupSchema);

      if (normalizedData.entities.customers) {
        dispatch(receiveCustomers(normalizedData.entities));
      }

      const siteGroup = normalizedData.entities.siteGroups[siteGroupId];
      if (siteGroup.weather_configuration != null) {
        dispatch(loadSiteGroupWeatherConfigurationForSiteGroup(siteGroupId));
      }

      dispatch(loadSiteGroupCurfewForSiteGroup(siteGroupId));

      return normalizedData.entities.siteGroups[siteGroupId];
    } catch (e) {
      return rejectWithValue(e.response.data);
    }
  },
);
